export enum Severity {
  Log,
  Warning,
  Error
}

export interface LogMessage {
  /**
   * The log message
   */
  message: string;
  /**
   * Additional attributes to be sent with the log message
   */
  attributes?: unknown;
  /**
   * The severity of the error message
   * Severities above {@link Severity.Error} are automatically recorded in Datadog via datadogRum.addError
   */
  severity: Severity;
}

export interface DatadogSpan {
  /**
   * Adds a new event to the span
   * @param name The name of the event
   * @param attributes Additional attributes to attach to the event
   */
  addEvent(name: string, attributes?: unknown): this;
  /**
   * Adds a new error event to the span
   * @param name The name of the error event
   * @param attributes Additional attributes to attach to the event
   * @param severity The severity of the error
   */
  addErrorEvent(name: string, attributes?: unknown, severity?: Severity): this;
  /**
   * Ends the span and records the metrics
   * @param attributes
   */
  end(attributes?: object): void;
}
